module.exports = vendors_dll;